'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { GavValues, Purchase } from './types';
import { calculateGav } from './calculations';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['gav'];
}

export default function GavCalculator({ translations }: Props) {
  const [values, setValues] = useState<GavValues>({
    numPurchases: 2,
    feeMode: 'without',
    purchases: [
      { shares: 0, pricePerShare: 0, fee: 0 },
      { shares: 0, pricePerShare: 0, fee: 0 }
    ]
  });

  const result = useMemo(() => calculateGav(values, translations), [values, translations]);

  return (
    <section id="gav-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div>
            <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 gap-8">
          <CalculatorInputs values={values} onValuesChange={setValues} translations={translations} />
          <ResultsDisplay result={result} translations={translations} />
        </div>
      </div>
    </section>
  );
}


